<template>
  <!-- About Us -->
  <!--Welcome Section-->
  <section class="welcome-section-two alternate wow fadeInUp animated">
    <div class="lower-row">
      <div class="auto-container">
        <div class="row clearfix">
          <div class="text-col col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="inner about_inner">
              <div class="sec-title with-separator wow fadeInUp animated">
                <h2>{{ data.title }}</h2>
                <!-- <div class="separator"><span class="cir c-1"></span><span class="cir c-2"></span><span class="cir c-3"></span>
                                </div> -->
              </div>
              <div class="about_inner_text_wrap">
                <!-- src="/images/AK/map.png" -->
                <img
                  class="about_inner_img wow bounceInRight animated"
                  :src="data.image"
                  data-wow-delay="0.5s"
                  style="visibility: visible; animation-delay: 0.5s; animation-name: bounceInRight"
                />
                <div class="about_inner_text fadeInUp animated">
                  <div class="content_main" v-html="data.contents"></div>
                  <!-- <div class="text">Abu Khema Field, approximately 1810 km2, located in the southern part of the Iraqi province of Muthanna, bordering with Saudi Arabia and Kuwait. China ZhenHua Oil was awarded the rights to explore and develop Abu Khema Field among the Iraq’s Fifth+ and Sixth Petroleum Licensing Rounds. The Abu Khema EDPC took effect since December 15, 2024, with maximum 34 years contract term.
                                    </div>
                                    <div class="text">China ZhenHua Oil Co., Ltd. (hereinafter referred to as "ZhenHua Oil") was established in 2003, and, headquartered in Beijing, is the national key support of the investment in petroleum industry, E&P, international oil and gas trade, oil storage and transportation, and refining.
                                    </div>

                                    <div class="text">
                                        ZhenHua Oil, started its operations in Iraq in 2008, and now we are the operator of Four Project, including Abu Khema DPSC, EBS DPSC, Ahdeb SDPC and Qurnain EDPC with the supports of Thi-Qar Oil Company (TOC) and Midland Oil Company (MdOC) respectively. ZhenHua Oil promoted the Operations in Iraq as Core Market among its global portfolios, and set up long-term ZhenHua Oil Scholarship Program to support Iraqi youth to gain their Bachelor, Master or Doctor degree in China, to share the growth with local people aiming to construct Iconic high-quality projects between Iraq and China.
                                    </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import api from '@/api/index.js'
export default {
  name: 'aboutUsText',
  data() {
    return {
      loading: false,
      Page: {
        total: 10,
        currentPage: 1,
        pageSize: 10,
        orders: [],
      },
      data: [],
    }
  },
  created() {},
  mounted() {
    // this.init()
  },
  methods: {
    init(data) {
      this.loading = true
      if (data) {
        this.data = data
      } else {
        api
          .webList({
            pageNo: this.Page.currentPage,
            pageSize: this.Page.pageSize,
            isPublished: '1', //是发布的
            columnName: 'About Us',
          })
          .then((res) => {
            this.data = res.page.list[0]
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>
<style scoped lang="scss"></style>
